<template>
  <div class="container-fluild">
    <h2>Records</h2>

    <div class="row">
      <div class="col offset-md-10">
        <!-- <button class="btn btn-primary">Add Record</button> -->
        <router-link :to="{ name: 'new_records'}" class="btn btn-primary">Add Record</router-link>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <table class="table is-hoverable">
          <thead>
            <tr>
              <td>Name</td>
              <td>Category</td>
              <td>Start</td>
              <td>End</td>
              <td>Image</td>
              <td>Event</td>
              <td></td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="record in records" v-bind:key="record.id">
              <td>{{ record.name }}</td>
              <td>{{ record.category }}</td>
              <td>{{ record.start }}</td>
              <td>{{ record.end }}</td>
              <td>
                <img v-bind:src="record.imageUrl" width="80" height="80">
              </td>
              <td>
                <table>
                  <tbody>
                    <tr v-for="event in record.events" v-bind:key="event.content">
                      <td>{{ event.start }}</td>
                      <td>{{ event.content }}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td>
                <router-link
                  :to="{ name: 'edit_records', params: { id: record.id, record: record }}"
                  class="btn btn-primary"
                >Edit</router-link>
              </td>
              <td>
                <button @click="onDeleteRecord(record)" class="btn btn-danger">Delete</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "records",
  data: function() {
    return {
      category: "people",
      name: "yuto",
      start: null,
      end: null,
      imageUrl: "",
      events: [],
      imageUploadType: "url" // url or upload
    };
  },
  computed: {
    ...mapGetters(["records"])
  },
  created: async function() {
    this.scanRecords();
  },
  methods: {
    onDeleteRecord: function(record) {
      this.deleteRecord(record);
    },
    ...mapActions(["scanRecords", "deleteRecord"])
  }
};
</script>

<style scoped>
div.container-fluild {
  margin: 20px;
}
div.row {
  margin-bottom: 10px;
}
</style>